function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.88281 32.7224C10.9127 10.6476 86.305 20.604 170.272 54.9597C254.239 89.3154 314.985 135.066 305.955 157.133",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeDasharray: "2.8 2.24"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2969 165.195L47.3798 204.696H65.8377L100.705 123.338H82.2475L55.1254 187.376L43.7304 165.195H25.2969Z",
  fill: "#2F7067",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M60.7505 204.696H17.4463V248H60.7505V204.696Z",
  fill: "#FBE8B0",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M125.011 161.4H81.707V204.704H125.011V161.4Z",
  fill: "#FBEAE2",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6992 248H198.286",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M74.9566 204.696H31.6523V248H74.9566V204.696Z",
  fill: "#FBE8B0",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M118.261 204.696H74.957V248H118.261V204.696Z",
  fill: "#92D8C4",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M139.214 161.4H95.9102V204.704H139.214V161.4Z",
  fill: "#FBEAE2",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M161.559 204.696H118.255V248H161.559V204.696Z",
  fill: "#FFBFC6",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6562 165.195L51.731 204.696H70.189L105.057 123.338H86.5987L59.4848 187.376L48.0898 165.195H29.6562Z",
  fill: "#2F7067",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M158.113 81.0089C180.207 81.0089 198.117 63.0983 198.117 41.0044C198.117 18.9106 180.207 1 158.113 1C136.019 1 118.108 18.9106 118.108 41.0044C118.108 63.0983 136.019 81.0089 158.113 81.0089Z",
  fill: "white",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M48.8042 127.702C54.8057 127.702 59.6709 122.837 59.6709 116.836C59.6709 110.834 54.8057 105.969 48.8042 105.969C42.8027 105.969 37.9375 110.834 37.9375 116.836C37.9375 122.837 42.8027 127.702 48.8042 127.702Z",
  fill: "#2F7067",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7267 130.474C32.8879 130.474 36.2611 127.101 36.2611 122.94C36.2611 118.778 32.8879 115.405 28.7267 115.405C24.5656 115.405 21.1924 118.778 21.1924 122.94C21.1924 127.101 24.5656 130.474 28.7267 130.474Z",
  fill: "#2F7067",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M30.3017 118.437C37.5466 118.437 43.4197 112.564 43.4197 105.319C43.4197 98.0738 37.5466 92.2006 30.3017 92.2006C23.0568 92.2006 17.1836 98.0738 17.1836 105.319C17.1836 112.564 23.0568 118.437 30.3017 118.437Z",
  fill: "#2F7067",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M45.4719 113.731C49.633 113.731 53.0062 110.358 53.0062 106.196C53.0062 102.035 49.633 98.6621 45.4719 98.6621C41.3107 98.6621 37.9375 102.035 37.9375 106.196C37.9375 110.358 41.3107 113.731 45.4719 113.731Z",
  fill: "#2F7067",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M46.2847 165.171H31.6955L26.4531 144.665H51.527L46.2847 165.171Z",
  fill: "#FBE8B0",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M40.4478 144.665C40.4478 144.665 52.4036 134.66 42.7804 129.515C33.1572 124.37 21.299 122.558 27.9393 113.211",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M38.3477 127.385C38.3477 127.385 51.0106 121.346 46.5241 114.121C42.9154 108.31 46.5241 105.319 46.5241 105.319",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2627 105.514C36.2627 105.514 34.369 112.829 29.281 113.211C24.1931 113.593 26.03 107.44 26.03 107.44",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M46.9805 120.274C46.9805 120.274 50.4754 122.175 55.2544 117.998",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M149.856 50.9933L139.688 40.8256L136.226 44.2636L149.856 57.8937L179.115 28.6341L175.677 25.196L149.856 50.9933Z",
  fill: "#2F7067"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M45.0807 36.8593C53.8518 36.8593 60.9622 29.749 60.9622 20.9779C60.9622 12.2068 53.8518 5.09637 45.0807 5.09637C36.3096 5.09637 29.1992 12.2068 29.1992 20.9779C29.1992 29.749 36.3096 36.8593 45.0807 36.8593Z",
  fill: "#FBE8B0",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M54.322 20.9777C54.3587 22.2138 54.1469 23.4447 53.6992 24.5974C53.2515 25.7502 52.577 26.8013 51.7156 27.6886C50.8542 28.5759 49.8235 29.2813 48.6846 29.763C47.5456 30.2447 46.3215 30.4929 45.0849 30.4929C43.8483 30.4929 42.6242 30.2447 41.4853 29.763C40.3463 29.2813 39.3156 28.5759 38.4542 27.6886C37.5929 26.8013 36.9184 25.7502 36.4706 24.5974C36.0229 23.4447 35.8111 22.2138 35.8478 20.9777",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M39.1248 16.1987C39.5108 16.1987 39.8237 15.8858 39.8237 15.4998C39.8237 15.1137 39.5108 14.8008 39.1248 14.8008C38.7387 14.8008 38.4258 15.1137 38.4258 15.4998C38.4258 15.8858 38.7387 16.1987 39.1248 16.1987Z",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M50.5984 16.1987C50.9844 16.1987 51.2974 15.8858 51.2974 15.4998C51.2974 15.1137 50.9844 14.8008 50.5984 14.8008C50.2124 14.8008 49.8994 15.1137 49.8994 15.4998C49.8994 15.8858 50.2124 16.1987 50.5984 16.1987Z",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M225.681 86.8688C225.681 86.8688 212.88 102.888 206.516 108.147C200.152 113.406 198.73 113.349 194.511 106.318C190.293 99.2879 183.45 82.6506 183.45 82.6506C182.627 81.3082 181.729 80.0138 180.759 78.7737C179.069 76.6036 177.143 71.54 177.907 68.4922C178.297 66.9479 179.532 63.965 181.548 70.7435C182.31 72.9332 183.653 74.8746 185.433 76.3598C185.433 76.3598 188.294 71.6782 188.725 72.7186C189.155 73.7589 186.92 79.8547 186.92 79.8547C186.92 79.8547 196.186 94.9152 201.347 102.718C204.956 99.0847 214.351 84.4305 214.351 84.4305",
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M225.681 86.8688C225.681 86.8688 212.88 102.888 206.516 108.147C200.152 113.406 198.73 113.349 194.511 106.318C190.293 99.2879 183.45 82.6506 183.45 82.6506C182.627 81.3082 181.729 80.0138 180.759 78.7737C179.069 76.6036 177.143 71.54 177.907 68.4922C178.297 66.9479 179.532 63.965 181.548 70.7435C182.31 72.9332 183.653 74.8746 185.433 76.3598C185.433 76.3598 188.294 71.6782 188.725 72.7186C189.155 73.7589 186.92 79.8547 186.92 79.8547C186.92 79.8547 196.186 94.9152 201.347 102.718C204.956 99.0847 214.351 84.4305 214.351 84.4305",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M225.963 111.138C229.019 123.679 245.128 119.705 243.104 109.204C241.479 100.54 251.955 98.7027 251.85 88.0717C251.769 79.7652 243.226 80.5373 244.413 70.8735C246.038 57.3735 235.31 48.4005 229.474 48.9857C224.167 45.9622 217.892 47.734 215.357 50.7006C212.821 53.6672 216.039 55.4066 216.039 55.4066L225.979 57.6742",
  fill: "#27262A"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M225.963 111.138C229.019 123.679 245.128 119.705 243.104 109.204C241.479 100.54 251.955 98.7027 251.85 88.0717C251.769 79.7652 243.226 80.5373 244.413 70.8735C246.038 57.3735 235.31 48.4005 229.474 48.9857C224.167 45.9622 217.892 47.734 215.357 50.7006C212.821 53.6672 216.039 55.4066 216.039 55.4066L225.979 57.6742",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeLinejoin: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M233.052 105.961C233.052 105.961 246.804 111.455 247.747 113.649C248.689 115.844 255.305 137.22 254.029 139.089C252.753 140.958 237.156 146.997 237.156 146.997",
  fill: "#92D8C4"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M233.052 105.961C233.052 105.961 246.804 111.455 247.747 113.649C248.689 115.844 255.305 137.22 254.029 139.089C252.753 140.958 237.156 146.997 237.156 146.997",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M181.363 248H296.134",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M185.048 193.772C184.414 196.698 207.505 199.957 208.537 196.519C209.569 193.081 197.654 190.911 197.654 190.911C197.654 190.911 185.853 190.107 185.048 193.772Z",
  fill: "#27262A",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M211.162 125.857C211.162 125.857 190.493 169.787 191.046 180.581C191.81 195.089 203.238 232.297 203.238 232.297L210.301 232.2L205.627 184.734C205.627 184.734 212.129 167.837 229.636 144.949C235.049 137.894 236.699 127.271 236.699 127.271L211.162 125.857Z",
  fill: "white",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M214.089 133.725L230.198 232.322H237.155L237.139 125.857H210.472",
  fill: "white"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M214.089 133.725L230.198 232.322H237.155L237.139 125.857H210.472",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M237.17 232.322H230.147C230.147 232.322 225.116 241.124 221.638 243.107C218.159 245.09 217.273 244.733 218.338 247.984H241.306C241.306 247.984 241.055 244.139 240.429 240.319C239.803 236.499 237.17 232.322 237.17 232.322Z",
  fill: "#FBB0B0",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M210.234 232.322H203.211C203.211 232.322 196.961 241.124 193.206 243.107C189.451 245.09 188.614 244.733 189.224 247.984H212.192C212.192 247.984 212.477 244.139 212.379 240.319C212.15 237.546 211.423 234.837 210.234 232.322Z",
  fill: "#FBB0B0",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M185.048 193.772C185.048 191.594 208.537 194.691 208.537 196.519C210.471 188.847 221.712 161.351 221.712 161.351L215.063 125.874H209.447C209.447 125.874 189.063 170.633 187.242 179.687C186.237 184.335 185.504 189.038 185.048 193.772Z",
  fill: "#FBEAE2",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeLinejoin: "round"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M212.098 138.992C212.098 138.992 208.798 172.526 211.732 186.945C211.472 187.668 216.186 175.721 216.186 175.721",
  fill: "#27262A"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M212.098 138.992C212.098 138.992 208.798 172.526 211.732 186.945C211.472 187.668 216.186 175.721 216.186 175.721",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M211.981 137.984C211.689 153.532 211.981 180.402 216.858 196.503C220.169 197.58 223.596 198.262 227.066 198.535C230.965 198.922 234.902 198.622 238.697 197.649C238.697 197.649 237.478 158.701 240.38 148.468C243.281 138.236 237.129 125.841 237.129 125.841H212.437",
  fill: "#FBEAE2"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M211.981 137.984C211.689 153.532 211.981 180.402 216.858 196.503C220.169 197.58 223.596 198.262 227.066 198.535C230.965 198.922 234.902 198.622 238.697 197.649C238.697 197.649 237.478 158.701 240.38 148.468C243.281 138.236 237.129 125.841 237.129 125.841H212.437",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeLinejoin: "round"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M232.635 85.7229C230.262 90.4776 232.286 99.9138 238.983 96.7115C240.047 92.9809 241.047 89.8274 241.161 86.4381C241.232 84.7865 240.736 83.1604 239.755 81.8297C237.812 81.0007 234.992 80.9845 232.635 85.7229Z",
  fill: "white",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M221.708 84.6012C224.118 84.4912 226.471 83.8294 228.584 82.6668C230.698 81.5043 232.517 79.8721 233.9 77.8959C228.663 76.2551 223.012 76.5434 217.97 78.7087C216.499 81.0738 215.125 84.9182 221.708 84.6012Z",
  fill: "white",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M233.901 77.8958C232.517 79.872 230.699 81.5042 228.585 82.6668C226.471 83.8293 224.119 84.4911 221.709 84.6011C215.126 84.9181 216.5 81.0737 217.971 78.6761C217.282 78.981 216.612 79.3256 215.963 79.7083C206.364 85.4708 209.981 89.2258 211.899 92.5825C213.817 95.9392 209.461 125.906 209.461 125.906H237.152C235.088 111.52 237.152 103.262 238.997 96.7601C232.3 99.9624 230.276 90.5262 232.649 85.7715C235.022 81.0168 237.827 81.0493 239.769 81.8784C238.27 79.9775 236.221 78.5864 233.901 77.8958Z",
  fill: "#FBE8B0",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M240.275 82.6506C240.275 82.6506 260.228 106.977 260.594 110.187C260.96 113.398 244.225 139.934 241.144 140.39C238.064 140.845 237.942 139.471 233.878 140.39C229.814 141.308 228.189 138.098 231.651 136.269C235.114 134.44 240.323 134.895 240.323 134.895L239.73 132.993L242.876 133.058L252.426 110.976L235.114 93.4279",
  fill: "white"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M240.275 82.6506C240.275 82.6506 260.228 106.977 260.594 110.187C260.96 113.398 244.225 139.934 241.144 140.39C238.064 140.845 237.942 139.471 233.878 140.39C229.814 141.308 228.189 138.098 231.651 136.269C235.114 134.44 240.323 134.895 240.323 134.895L239.73 132.993L242.876 133.058L252.426 110.976L235.114 93.4279",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M220.567 80.1473L220.884 71.5726C220.459 71.6758 220.017 71.6758 219.592 71.5726C219.168 71.4694 218.775 71.2659 218.445 70.9793C216.243 68.8905 215.519 59.8606 215.869 53.9111C216.218 47.9617 229.913 50.5382 229.913 50.5382L228.597 67.777L230.629 78.6599",
  fill: "white"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M220.567 80.1473L220.884 71.5726C220.459 71.6758 220.017 71.6758 219.592 71.5726C219.168 71.4694 218.775 71.2659 218.445 70.9793C216.243 68.8905 215.519 59.8606 215.869 53.9111C216.218 47.9617 229.913 50.5382 229.913 50.5382L228.597 67.777L230.629 78.6599",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M228.597 67.7445L226.581 63.3637C227.305 62.8847 227.846 62.1758 228.117 61.3515C228.389 60.5272 228.374 59.6355 228.077 58.8203C227.974 58.5662 227.801 58.3473 227.576 58.19C227.352 58.0328 227.087 57.9441 226.813 57.9346C226.54 57.9251 226.269 57.9953 226.035 58.1367C225.8 58.2781 225.611 58.4845 225.492 58.7309C225.192 59.3171 225.018 59.9592 224.98 60.6165C224.98 60.6165 224.931 51.5054 215.869 53.1716L215.763 52.2694C215.763 52.2694 214.138 49.4898 222.2 49.2215C226.161 49.0717 230.03 50.4445 233.01 53.0578C233.01 53.0578 233.384 55.5774 231.864 60.5434C231.071 63.0674 229.974 65.4855 228.597 67.7445Z",
  fill: "#27262A",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeLinejoin: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M220.891 71.5725C225.922 69.8494 225.515 65.5011 225.515 65.5011L220.891 71.5725Z",
  fill: "white"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M220.891 71.5725C225.922 69.8494 225.515 65.5011 225.515 65.5011",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M183.668 83.1869L187.455 80.7242L190.121 85.0238L186.309 89.3883L183.668 83.1869Z",
  fill: "#2F7067",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M211.273 111.601C211.273 111.601 215.093 94.1431 234.193 78.2778",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M247.744 113.65L242.566 101.312",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M305.955 157.133C296.966 179.199 221.533 169.251 137.566 134.895C53.5988 100.54 -7.10677 54.7971 1.88244 32.7224",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeDasharray: "2.8 2.24"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M160.284 158.888C169.055 158.888 176.165 151.778 176.165 143.007C176.165 134.236 169.055 127.125 160.284 127.125C151.513 127.125 144.402 134.236 144.402 143.007C144.402 151.778 151.513 158.888 160.284 158.888Z",
  fill: "#FBE8B0",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M169.525 143.007C169.454 145.409 168.449 147.689 166.725 149.363C165 151.037 162.691 151.974 160.288 151.974C157.884 151.974 155.576 151.037 153.851 149.363C152.126 147.689 151.122 145.409 151.051 143.007",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M154.325 138.219C154.711 138.219 155.024 137.906 155.024 137.52C155.024 137.134 154.711 136.821 154.325 136.821C153.939 136.821 153.626 137.134 153.626 137.52C153.626 137.906 153.939 138.219 154.325 138.219Z",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M165.801 138.219C166.187 138.219 166.5 137.906 166.5 137.52C166.5 137.134 166.187 136.821 165.801 136.821C165.414 136.821 165.102 137.134 165.102 137.52C165.102 137.906 165.414 138.219 165.801 138.219Z",
  stroke: "#27262A",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 249,
    viewBox: "0 0 308 249",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.fc77d317.svg";
export { ForwardRef as ReactComponent };